<div class="dialogue-content">
    <mat-dialog-content>
        <div class="text-center">
            <form novalidate>
                <img src="../../../assets/images/change-status.svg" class="mb-4 m-auto d-table" />
                <h5 class="text-primary"></h5>
                <p class="fs-6 mb-0">
                    <span class="{{ title === 'Active' ? 'active-title' : 'inactive-title' }}">
                        {{ title }}
                    </span>
                </p>
                <span class="fw-bolder">{{ action }}</span>
                <div class="d-flex align-items-center mt-4 flex-nowrap justify-content-center gap-3">

                    <button matButton="filled" type="button" class="dialog-btn-secondary" mat-dialog-close
                        (click)="close()">No</button>
                    <button matButton="filled" type="button" class="dialog-btn-primary"
                        (click)="confirmStatusChange()">Yes</button>
                </div>
            </form>
        </div>
    </mat-dialog-content>
</div>